"use client";
import { Skeleton } from "@/components/ui/skeleton";
import { TableCell, TableRow } from "@/components/ui/table";

export function ContractRowSkeleton({ number }: { number: number }) {
  return (
    <>
      {Array.from({ length: number }).map((_, index) => (
        <TableRow key={index}>
          <TableCell className="w-[50px] hidden sm:table-cell">
            <Skeleton className="h-[40px] w-[40px] rounded-full" />
          </TableCell>
          <TableCell className="w-1/4 font-medium">
            <Skeleton className="h-[23px] w-full rounded-xl" />
          </TableCell>
          <TableCell className="w-1/10">
            <Skeleton className="h-[23px] w-full rounded-xl" />
          </TableCell>
          <TableCell className="w-1/10 hidden md:table-cell">
            <Skeleton className="h-[23px] w-full rounded-xl" />
          </TableCell>
          <TableCell className=" w-1/10 hidden md:table-cell">
            <Skeleton className="h-[23px] w-fullrounded-xl" />
          </TableCell>
          <TableCell className="w-1/12 hidden md:table-cell">
            <Skeleton className="h-[23px] w-full rounded-xl" />
          </TableCell>
          <TableCell className="w-1/3 hidden md:table-cell">
            <Skeleton className="h-[23px] w-full rounded-xl" />
          </TableCell>
          <TableCell className="w-[50px]">
            <Skeleton className="h-[10px] w-[16px] rounded-xl" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
